/* @flow */
import produce from 'immer'

export default function reducer(state, action: any) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'ADD_BLOCK':
        draft.blocks.push(initialState.blocks[0])
        break
      case 'CHANGE_TITLE':
        draft.title = action.value
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_BLOCK_TITLE':
        const { newTitle, idx } = action.value
        draft.blocks[idx].title = newTitle
        break
      case 'CHANGE_BLOCK_PARAGRAPH':
        const { newParagraph, idx: _idx } = action.value
        draft.blocks[_idx].paragraph = newParagraph
        break
      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }
      case 'CHANGE_BLOCK_TITLE_ALIGNMENT': {
        const { idx, alignment } = action.value
        draft.blocks[idx].blockTitleAlignment = alignment
        break
      }
      case 'CHANGE_BLOCK_PARAGRAPH_ALIGNMENT': {
        const { idx, alignment } = action.value
        draft.blocks[idx].blockParagraphAlignment = alignment
        break
      }
      case 'REMOVE_BLOCK':
        const { idx: idx__ } = action.value
        draft.blocks.splice(idx__, 1)
        break
      case 'CHANGE_LINK_DATA':
        const { linkIdx, linkData } = action.value
        draft.blocks[linkIdx].additionalUrl = linkData.link
        draft.blocks[linkIdx].additionalText = linkData.text
        break
      case 'CHANGE_ICON':
        const { idx: idx_, iconName } = action.value
        draft.blocks[idx_].icon = iconName
        break
      case 'REMOVE_LINK': {
        const { idx } = action.value
        draft.blocks[idx].additionalUrl = ''
        draft.blocks[idx].additionalText = ''
        break
      }
      case 'REMOVE_ICON': {
        const { idx } = action.value
        draft.blocks[idx].icon = ''
        break
      }
      case 'ADD_ICON':
        draft.blocks[action.value].icon = 'edit'
        break
      case 'ADD_LINK': {
        const { additionalUrl, additionalText } = initialState.blocks[0]
        const { idx } = action.value
        draft.blocks[idx].additionalUrl = additionalUrl
        draft.blocks[idx].additionalText = additionalText
        break
      }
      case 'REMOVE_BACKGROUND_IMAGE':
        draft.backgroundImgUrl = ''
        draft.backgroundImgDimensions = {}
        break
      case 'CHANGE_BACKGROUND_IMAGE':
        const { url, dimensions } = action.value
        draft.backgroundImgUrl = url
        draft.backgroundImgDimensions = dimensions
        break
      case 'CHANGE_BG_OVERLAY_TRANSPARENCY':
        draft.bgOverlayTransparency = action.value
        break
    }
  })
}
